var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "notice",
    attrs: {
      "id": "notice"
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.transitionName,
      "mode": "out-in"
    }
  }, [_c('TransactionInfo', {
    key: _vm.SELECTED_TRANSACTION.owner_id,
    attrs: {
      "transaction": _vm.SELECTED_TRANSACTION
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }